/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prescription_Reason_Same_Muscle_PopularInputs */

const en_us2_prescription_reason_same_muscle_popular = /** @type {(inputs: Prescription_Reason_Same_Muscle_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A popular pick for the same muscle`)
};

const pt_br2_prescription_reason_same_muscle_popular = /** @type {(inputs: Prescription_Reason_Same_Muscle_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma escolha popular para o mesmo músculo`)
};

const es_419_prescription_reason_same_muscle_popular = /** @type {(inputs: Prescription_Reason_Same_Muscle_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una opción popular para el mismo músculo`)
};

const pt_pt2_prescription_reason_same_muscle_popular = /** @type {(inputs: Prescription_Reason_Same_Muscle_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma escolha popular para o mesmo músculo`)
};

const fr_fr2_prescription_reason_same_muscle_popular = /** @type {(inputs: Prescription_Reason_Same_Muscle_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un choix populaire pour le même muscle`)
};

const de_de2_prescription_reason_same_muscle_popular = /** @type {(inputs: Prescription_Reason_Same_Muscle_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine beliebte Wahl für denselben Muskel`)
};

const it_it2_prescription_reason_same_muscle_popular = /** @type {(inputs: Prescription_Reason_Same_Muscle_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una scelta diffusa per lo stesso muscolo`)
};

/**
* | output |
* | --- |
* | "A popular pick for the same muscle" |
*
* @param {Prescription_Reason_Same_Muscle_PopularInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_reason_same_muscle_popular = /** @type {((inputs?: Prescription_Reason_Same_Muscle_PopularInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Reason_Same_Muscle_PopularInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_reason_same_muscle_popular(inputs)
	if (locale === "es-419") return es_419_prescription_reason_same_muscle_popular(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_reason_same_muscle_popular(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_reason_same_muscle_popular(inputs)
	if (locale === "de-DE") return de_de2_prescription_reason_same_muscle_popular(inputs)
	if (locale === "it-IT") return it_it2_prescription_reason_same_muscle_popular(inputs)
	return en_us2_prescription_reason_same_muscle_popular(inputs)
});
export { prescription_reason_same_muscle_popular as "prescription.reason.same_muscle_popular" }